import { render, staticRenderFns } from "./AssignLaboratoryRelationField.vue?vue&type=template&id=48fd4508&scoped=true"
import script from "./AssignLaboratoryRelationField.vue?vue&type=script&lang=js"
export * from "./AssignLaboratoryRelationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd4508",
  null
  
)

export default component.exports